import { matchPath } from 'react-router-dom'

/**
 * VAPT W1 (Improper Access Control) — defense-in-depth route guard.
 *
 * These admin views are shown only under the SUPER_ADMIN menu, but every route was previously
 * wrapped in a login-only <Protected> guard, so a lower-privilege user (WHILTER_ADMIN /
 * CONTENT_CREATOR / WHILTER_CONTENT_CONTRIBUTOR) could reach them by typing the URL. The list below
 * mirrors the server-side RBAC in admin-2.0 SecurityConfig (SUPER_ADMIN_PATHS); the *authoritative*
 * check is server-side — this just stops the SPA from rendering the view.
 *
 * NOTE on /usecase: that namespace is overloaded — usecase authoring (SUPER_ADMIN) AND campaign
 * dashboards (e.g. /usecase/:id/:slug/dashboard, reachable by CONTENT_CREATOR). We therefore gate
 * only the unambiguous config routes and deliberately leave the dashboard/iteration routes open.
 */
export const SUPER_ADMIN_ONLY_PATTERNS = [
  // brand management
  '/brand',
  '/brand/*',
  // client configuration + onboarding
  '/client-configuration',
  '/client-configuration/*',
  '/customer',
  '/customer/*',
  // schema / metadata / client requests
  '/schema',
  '/schema/*',
  '/metadata',
  '/metadata/*',
  '/client/*',
  // ML playgrounds
  '/tts-playground',
  '/vc-playground',
  '/ls-playground',
  '/mlt-playground',
  '/super-resolution',
  '/face-swap',
  // global + template cache library, final videos
  '/library/*',
  // workflow manager + composition tags
  '/dag/*',
  '/composition-tags',
  '/composition-tags/*',
  // usecase CONFIG only (NOT campaign dashboards / iteration views)
  '/usecase',
  '/usecase/add',
  '/usecase/:id/edit',
]

/** True when the path is one of the SUPER_ADMIN-only admin views. */
export const isSuperAdminOnlyPath = pathname =>
  SUPER_ADMIN_ONLY_PATTERNS.some(
    pattern => !!matchPath({ path: pattern, end: true }, pathname)
  )

/** True when the user's role set includes SUPER_ADMIN (roles may be an array or a single value). */
export const hasSuperAdmin = roles => {
  if (Array.isArray(roles)) {
    return roles.map(String).includes('SUPER_ADMIN')
  }
  return roles != null && String(roles) === 'SUPER_ADMIN'
}
